export default __webpack_public_path__ + "310f028eee42ed2ea81ecf50cdac6667.ttf";